import ESContext from "../ESContext";
import AnalyticsUtil from "../graphs/AnalyticsUtil";
import {YAxisFormatNumber} from "../graphs/GraphFormatting";
import {formatGermanDate} from "../../common/TimeUtil";
import HighChartsGraph from "../graphs/HighChartsGraph";
import CachedGraphV2 from "../graphs/CachedGraphV2";

class DAU_LineChart {
    static getUUID() {
        return "6b4b9452-299c-414b-bd69-11ad0d919ccb";
    }

    static getProps() {
        return [
            {id:"title",name:"Title", type:"string"},
            {id:"group",name:"Group by", type:"string"},
            {id:"minThreshold",name:"Min. Threshold",type:"number", default: 10},
            {id:"withSum",name:"with Sum", type:"boolean", showOnly: (_props) => {return _props.group && _props.group !== ""}},
            {id:"filter",name:"Filter", type:"filterTags"}
        ];
    }

    static getGraphSize() {
        return 1;
    }

    static getHeightRatio() {
        return "50%";
    }

    static calcDAU(_dauData, _minThreshold,  _groupName, _groupValue) {
        let dauData = _dauData;
        if (_groupName && _groupValue) {
            dauData = AnalyticsUtil.filterBy(_dauData, (_e) => _e[_groupName] === _groupValue);
        }
        let daus = {};
        for (let i = 0; i < dauData.length; i++) {
            const current = dauData[i];
            if (!daus[current.day]) {
                daus[current.day] = 0;
            }
            daus[current.day] += current.dau;
        }

        let series = [];
        for (let day in daus) {
            const current = daus[day];
            if (current >= _minThreshold) {
                series.push({name: _groupValue, x: new Date(day).getTime(), y: current, text: current+" Users"});
            }
        }
        return {name: _groupValue, data: series};
    }

    static getGraphData(ctx, _props, _cb) {
        let filter = JSON.parse(JSON.stringify(_props.filter));
        if (_props.dateSelection) {
            filter.day = {from: _props.dateSelection.start, to: _props.dateSelection.end};
        }
        ctx.sendAsync("dau","session_duration_v4",["cardinality:user_id:dau"],["day", _props.group], filter);
        return ctx.waitForCompletion((_err, _data) => {
            if (_err) {
                _cb(_err);
            } else {
                let dauData = _data.dau.result;
                let groups = AnalyticsUtil.getDistinct(dauData, _props.group);
                let series = [];
                if (groups.length > 0) {
                    for(let i = 0; i < groups.length; i++) {
                        let data = DAU_LineChart.calcDAU(dauData, _props.minThreshold, _props.group, groups[i]);
                        series.push(data);
                    }
                    if (_props.withSum) {
                        let data = DAU_LineChart.calcDAU(dauData, _props.minThreshold);
                        data.name = "Sum"
                        series.push(data);
                    }
                } else {
                    let data = DAU_LineChart.calcDAU(dauData, _props.minThreshold);
                    series.push(data);
                }
                let graphData = {
                    chart : {type: "line"},
                    legend: {enabled: groups.length > 1},
                    series : series,
                };
                return _cb(null, graphData);
            }
        });
    }

    static getXAxis() {
        return {type: "datetime", crosshair: true};
    }

    static getYAxis() {
        return YAxisFormatNumber();
    }

    static getTooltip() {
        return {
            split:true,
            formatter : function() {
                let result = [formatGermanDate(new Date(this.x))];
                for(let i = 0; i < this.points.length; i++) {
                    result.push(this.points[i].point.text);
                }
                return result;
            }
        };
    }
}

export default CachedGraphV2(DAU_LineChart, HighChartsGraph);